import React from 'react'
import Header from '../header/HeaderFour';
import Breadcrumb from '../inner/Breadcrumb';
import Footer from '../elements/Footer';
import Accordion from 'react-bootstrap/Accordion';




function BusinessConsultations() {
  return (
    <div className='Business-consultation'>
        <div className="">
            <Header/>
            <main>
                <Breadcrumb title="Business Consultations" sub_title="Service" active="Business Consultations"/>
                    {/* tmp service section */}
                    <div className="tmp-service-section tmp-section-gap">
                        <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                            <div className="tmp-large-service-detials">
                                <img
                                src="assets/images/services/business_consultation.jpg"
                                alt="business consultation"
                                />
                            </div>
                            {/* single service details component */}
                            <div className="single-service-details-component mt--40">
                                <h2 className="title split-collab">
                                Expert Business Consultation Services
                                </h2>
                                <p className="disc mb--20">
                              Our personalized business consultation services are designed to help you make informed decisions and achieve long-term success.  From business planning and financial analysis to identifying areas for improvement and managing risks, we work closely with you to develop practical solutions that drive results. With our hands-on approach and commitment to your success, you’ll have a trusted partner by your side every step of the way.
                                </p>
                                <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    {/* chck-area-wrapper */}
                                    <div className="check-service-wrapper">
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Instant Business Growth</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Expert Team Members</p>
                                    </div>
                                    </div>
                                    {/* chck-area-wrapper end */}
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    {/* chck-area-wrapper */}
                                    <div className="check-service-wrapper">
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Easy Customer Service</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>24/7 Quality Service</p>
                                    </div>
                                    </div>
                                    {/* chck-area-wrapper end */}
                                </div>
                                </div>
                            </div>
                            {/* single service details component end */}
                            <div className="row g-5 mt--10">
                                <div className="col-lg-6 col-md-6">
                                {/* single service large-details */}
                                <div className="single-service-details">
                                    
                                    <div className="information">
                                    <h6 className="title">Achieve More with Cost-Effective Business Solutions</h6>
                                    <p className="disc">
                                     We take the time to understand your goals and offer practical, result driven solutions to help you make informed decisions, improve performance and achieve long-term success while reducing costs and increasing productivity.
                                    </p>
                                    </div>
                                </div>
                                {/* single service large-details end */}
                                </div>
                                <div className="col-lg-6 col-md-6">
                                {/* single service large-details */}
                                <div className="single-service-details">
                                    
                                    <div className="information">
                                    <h6 className="title">Stay Ahead of Uncertainty with Expert Guidance</h6>
                                    <p className="disc">
                                      We also help you anticipate and manage unforeseen issues and risks that could disrupt your business. From navigating regulatory changes to preparing for economic shifts, our expert insight helps you stay resilient, agile and ready for whatever comes your way.
                                    </p>
                                    </div>
                                </div>
                                {/* single service large-details end */}
                                </div>
                            </div>
                            <div className="row g-5 mt--10">
                                <div className="col-lg-12">
                                <h2 className="title split-collab">
Supporting Your Business Growth and Operational Success</h2>
                                <p className="disc mb--20">
                                              From there, we offer hands-on guidance in areas such as business planning, budgeting, cash flow management, and performance improvement. We also assist in identifying inefficiencies, streamlining processes, and setting measurable goals to enhance your day-to-day operations. <br /><br />
                                              Our consultations go beyond surface-level advice we take a deep dive into your specific challenges and opportunities. We help you navigate regulatory compliance, manage financial risks, and create strategies to stay competitive in a constantly evolving marketplace. Whether you’re facing unexpected hurdles or simply want to improve profitability and sustainability, we provide ongoing support and practical solutions tailored to your business model. With our experience and personalized approach, you’ll have a reliable partner who’s just as invested in your success as you are.
                                </p>
                                </div>
                                
                                
                                
                            </div>
                            <div className="row mt--10">
                                <div className="col-lg-12">
                                <div className="faq-accordion">

                                    <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                        <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>What do your business consultation services include?</span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                                </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                                We offer strategic planning, financial analysis, and operational guidance to help businesses improve performance, streamline processes, and achieve long-term success.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>How can business consultation benefit my company?</span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                              Our consultation services provide expert insights and customized strategies to solve challenges, enhance efficiency, and unlock growth opportunities tailored to your business goals.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>
                                                   Do you work with startups and established businesses alike?
                                                </span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                                Yes! We assist startups, small businesses, and established enterprises with personalized advice and actionable plans that drive sustainable results.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    </Accordion>

                                    <div className="faq-buttom">
                                    <h4 className="title">Still Have More Questions?</h4>
                                    <p>
                                                      Contact Our <a style={{color:"#F8E3E3"}} href="/contact-us">Expert Support Team</a>
                                    </p>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-4 pl--50 pl_md--15 pl_sm--10 mt_md--50 mt_sm--50">
                            <div className="side-bar-details-page">
                                
                                {/* single bar */}
                                <div className="signle-side-bar category-area">
                                <div className="header">
                                    <h3 className="title">Service List</h3>
                                </div>
                                <div className="body">
                                    {/* single category */}
                                    <a href="/business-formation" className="single-category">
                                    <p>Business Formation</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/payroll-management" className="single-category">
                                    <p>Payroll Management</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/tax" className="single-category">
                                    <p>Tax</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/book-keeping" className="single-category">
                                    <p>Book Keeping</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    
                                </div>
                                </div>
                                {/* single bar end */}
                                {/* single bar */}
                                <div className="signle-side-bar call-to-action">
                                <div className="easy-call-to-action">
                                    <div className="icon-center-call">
                                    <i className="fa-light fa-phone" />
                                    </div>
                                    <h3 className="title">Need any help?</h3>
                                    <p className="disc">
                                    We are here to help our customer any time. You can call on
                                    24/7 To Answer Your Question.
                                    </p>
                                    <a href="tel:8323510418">832-351-0418</a>
                                </div>
                                </div>
                                {/* single bar end */}
                                {/* single bar */}
                                {/* <div className="signle-side-bar brochure">
                                <div className="header">
                                    <h3 className="title">Brochure</h3>
                                </div>
                                <div className="body">
                                    
                                    <a href="#" className="single-brocher">
                                    <p>Investment Policy</p>
                                    <i className="fa-light fa-cloud-arrow-down" />
                                    </a>
                                    
                                    <a href="#" className="single-brocher">
                                    <p>Company Details</p>
                                    <i className="fa-light fa-note" />
                                    </a>
                                  
                                </div>
                                </div> */}
                                {/* single bar end */}
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    {/* tmp service section end */}
                <Footer/>
            </main>
        </div>
    </div>
  )
}

export default BusinessConsultations